import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Allow Dropout Trainee")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = { class: "row mt-4" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Term", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "col-md-2 mt-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#batch_detail",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Allow Dropout Trainee")
  ])
], -1)
const _hoisted_28 = {
  id: "batch_detail",
  class: "collapse show"
}
const _hoisted_29 = { class: "collapse show" }
const _hoisted_30 = { class: "card-body border-top p-5" }
const _hoisted_31 = { class: "pt-0" }
const _hoisted_32 = { class: "row g-6 g-xl-6 mb-6 mb-xl-9" }
const _hoisted_33 = { class: "table-responsive mt-3" }
const _hoisted_34 = { class: "table table-borderless gy-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Allow For Next Term"),
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Photo"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Registration Number"),
    /*#__PURE__*/_createElementVNode("th", null, "Reference Number"),
    /*#__PURE__*/_createElementVNode("th", null, "Term Session"),
    /*#__PURE__*/_createElementVNode("th", null, "Term Present"),
    /*#__PURE__*/_createElementVNode("th", null, "Attendance Percentage"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_36 = { style: {} }
const _hoisted_37 = { class: "form-check form-switch" }
const _hoisted_38 = ["onUpdate:modelValue", "checked"]
const _hoisted_39 = ["src"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = ["data-kt-indicator"]
const _hoisted_42 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_43 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_44 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_Form, {
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      name: "tranche_id",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: tranche.id,
                            label: tranche.label,
                            value: tranche.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tranche.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Partner",
                      name: "entity_id",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.getTrainingInstitute
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: 
                        '[' + info.entity_short_name + '] - ' + info.entity_name
                      ,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Institute",
                      modelValue: _ctx.batch.institute_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                      name: "institute_id",
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.courseInfo
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.short_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.institute_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course",
                      modelValue: _ctx.batch.course_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                      name: "course_id",
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchInfo()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.course_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.course_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _hoisted_21,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Batch",
                      modelValue: _ctx.batch.batch_id,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.batch_id) = $event)),
                      name: "batch_id",
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.termInfo
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.batch_sequence_number,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.batch_sequence_number), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _hoisted_24,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Term",
                      modelValue: _ctx.batch.term_id,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.batch.term_id) = $event)),
                      name: "batch_id",
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.termList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.term_no,
                            label: info.term_no,
                            value: info.term_no
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.term_no), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.calenderDetails())),
                      type: "button",
                      class: "btn btn-success mt-6 p-3",
                      style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                    }, [
                      _createTextVNode(" Search "),
                      _hoisted_26
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.showcalendarDetails)
        ? (_openBlock(), _createElementBlock("div", {
            class: "card mb-5 mb-xl-10",
            key: _ctx.componentKey
          }, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("table", _hoisted_34, [
                          _hoisted_35,
                          _createElementVNode("tbody", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (info, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: index,
                                style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51)"}
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      "onUpdate:modelValue": ($event: any) => ((info.is_allowed_for_training) = $event),
                                      checked: info.is_allowed_for_training
                                    }, null, 8, _hoisted_38), [
                                      [_vModelCheckbox, info.is_allowed_for_training]
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("img", {
                                    src: 
                              _ctx.api_url +
                              info?.trainee_info?.attach_file_info?.file_path
                            ,
                                    alt: "",
                                    width: "32",
                                    height: "32"
                                  }, null, 8, _hoisted_39)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(info?.trainee_info?.trainee_name), 1),
                                _createElementVNode("td", null, _toDisplayString(info?.trainee_info?.registration_number), 1),
                                _createElementVNode("td", null, _toDisplayString(info?.trainee_info?.reference_number), 1),
                                _createElementVNode("td", null, _toDisplayString(info?.term_session), 1),
                                _createElementVNode("td", null, _toDisplayString(info?.term_present), 1),
                                _createElementVNode("td", null, _toDisplayString(info?.attendance_percentage), 1),
                                _createElementVNode("td", null, _toDisplayString(info?.status), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.tableData.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("button", {
                          "data-kt-indicator": _ctx.loading ? 'on' : null,
                          class: "btn btn-lg btn-success",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                          type: "button",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formSubmit()))
                        }, [
                          (!_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                _createTextVNode(" Submit "),
                                _createElementVNode("span", _hoisted_43, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                _createTextVNode(" Please wait... "),
                                _hoisted_45
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_41)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["validation-schema"])), [
    [_directive_loading, _ctx.loading]
  ])
}